import { Injectable } from '@angular/core';
import { MonStorage } from './mon-storage.class';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService implements Storage {
    private readonly tempStorage: Storage;
    get length (): number {
        return this.tempStorage.length;
    }

    constructor () {
        try {
            // trying to see if we have access to window.localStorage
            this.tempStorage = window.localStorage;
        } catch (e) {
            // otherwise create a local object that implements Storage interface
            this.tempStorage = {} as MonStorage;
        }
    }

    getItem (key: string): string | null {
        return this.tempStorage.getItem(key);
    }

    setItem (key: string, data: string): void {
        this.tempStorage.setItem(key, data);
    }

    key (index: number): string | null {
        return this.tempStorage.key(index);
    }

    clear (): void {
        this.tempStorage.clear();
    }

    removeItem (key: string): void {
        this.tempStorage.removeItem(key);
    }
}
